module.exports = __webpack_public_path__ + "1ecce635aab258d119d79643ede6ae13.png";